<template>
    <div class="infoCard">
        <h3 v-if="title" class="mb-2">{{ title }}</h3>
        <v-sheet rounded :style="contentStyles" class="contents" :class="{ empty: isEmpty }">
            <v-progress-circular v-if="loading" indeterminate color="blue" size="50"></v-progress-circular>
            <h3 v-else-if="isEmpty">{{ emptyTitle }}</h3>
            <slot v-else></slot>
            <div v-if="slots.menu" class="menu">
                <slot name="menu"></slot>
            </div>
        </v-sheet>
    </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'

const slots = useSlots()

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    title: {
        type: String
    },
    minHeight: {
        type: Number,
        default: 60
    },
    /**
     * Setting this will result in ONLY the emptyTitle rendering
     */
    isEmpty: {
        type: Boolean,
        default: false
    },
    emptyTitle: {
        type: String,
        default: 'Nothing to Show'
    }
})

const contentStyles = computed(() => {
    return {
        'min-height': `${props.minHeight}px`
    }
})
</script>

<style lang="scss" scoped>
.infoCard {
    h3 {
        font-size: 1em;
        font-weight: 500;
        text-align: left;
    }

    .empty {
        display: flex;
        align-items: center;
        justify-content: center;

        h3 {
            font-weight: 200;
        }
    }
}

.contents {
    position: relative;
}

.menu {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1000;
}
</style>
